module.exports = __webpack_public_path__ + "img/ball_3.3ba9a7af.png";